import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';
import { AiScrubBatchStatusResponse, AiScrubScope } from '../../models';

export const getAiScrubBatchStatus: (
  fetchContext: FetchContext,
  awardId: number,
  batchRunId: string,
  accessToken?: string,
  scope?: AiScrubScope,
) => Promise<AiScrubBatchStatusResponse> = (fetchContext, awardId, batchRunId, accessToken, scope = 'awards') =>
  fetch(`${fetchContext.baseUrl}/api/staff/${scope}/${awardId}/ai-scrub-batch/${encodeURIComponent(batchRunId)}`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  })
  .then((response) => responseErrorHandler<AiScrubBatchStatusResponse>(fetchContext.errorStore, response, 'get AI scrub batch'));
